export const API_ENDPONIT = {
  chartek_link: 'externaldriverintegration/chartek',
  order_link: 'integration/order',
};
